import React from 'react';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { shellTips } from '@bingads-webui-campaign-react/shell-ui-common';

export const audienceErrorHandler = (WrappedComponent, i18n) => (err) => {
  const errorCode = err.errors && err.errors[0].Code;
  const isUserError = (errorCode === 'TooMuchDataToDownload');
  if (!isUserError) {
    notificationApi.showWarning(i18n.getString(shellTips.shellDataError));
  }

  return (<WrappedComponent audienceFromOData={{ dataNotReady: true }} />);
};
